// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"f6701a83","506":"ec95b4b9","707":"490df2d7"}[chunkId] + ".js";
};